import { h } from 'preact';
import { isFocusStudio } from 'utils/studioConfig';

import FocusHomeEntEditor from 'components/editor/movies/homeEnt/homeEntFocus';
import UniversalHomeEntEditor from 'components/editor/movies/homeEnt/homeEntUniversal';

export default (props) => {
	if (isFocusStudio()) return <FocusHomeEntEditor {...props} />;
	return <UniversalHomeEntEditor {...props} />;
};